import Footer from '@/layout/Footer';
import Header from '@/layout/Header';
import { PageLayout } from '@/layout/PageLayout';
import {
  getAllCollectionElements,
  getCollectionElementBySlug,
} from '../content/api';

import tosIcon from '../public/images/icons/tos.svg';

export default function Page({
  title,
  htmlContent,
}: {
  title: string;
  htmlContent: string;
}) {
  return (
    <PageLayout title={title}>
      <Header className="sticky top-0 section-middleground lg:bg-transparent z-10 mb-8" />
      <main className="prose mx-auto px-4">
        <img className="block mx-auto" {...tosIcon} alt="" />
        <h1 className="text-center">{title}</h1>
        <div
          className="overflow-x-scroll lg:overflow-x-visible"
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </main>

      <Footer className="text-center" />
    </PageLayout>
  );
}

export async function getStaticProps({ params }) {
  const page = await getCollectionElementBySlug('pages', params.slug, [
    'title',
    'htmlContent',
  ]);

  return {
    props: page,
  };
}

export async function getStaticPaths() {
  const pages = await getAllCollectionElements('pages', ['slug']);

  const paths = pages.map(({ slug }) => ({
    params: { slug },
  }));

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: false };
}
